// extracted by mini-css-extract-plugin
module.exports = {"quantity":"AccessoryItem_quantity__3Ia1I"};